import axios from 'axios';

import config from './index';
import { getAuthToken } from 'src/lib/localStorage';
import paramsEncoder from 'src/lib/paramEncoder';
import { revokeAuth } from 'src/redux/slices/authReducer';
import { resetProfile } from 'src/redux/slices/profileReducer';
import { store } from 'src/redux/store';
import { toast } from 'src/lib/toast';

axios.defaults.baseURL = config.API_URL;
axios.defaults.paramsSerializer = paramsEncoder;
axios.defaults.headers.common['Authorization'] = getAuthToken();
axios.defaults.headers.common['TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;

axios.interceptors.request.use((config) => {
  config.headers['TIMESTAMP'] = new Date().toISOString();
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem('admin_token');
      store.dispatch(revokeAuth({}));
      store.dispatch(resetProfile({}));
      toast(
        {
          message: 'logout successfully',
          type: 'success',
        },
        store.dispatch,
      );
      return;
    }
    throw error;
  },
);

export const setAuthorization = (token) => {
  axios.defaults.headers.common['Authorization'] = token;
};

export const handleResponse = (responseData, type = 'success', doc = false) => {
  try {
    if (doc && type === 'success' && responseData && responseData.data) {
      return { data: responseData.data };
    }
    if (type === 'success' && responseData && responseData.data) {
      return responseData.data;
    } else if (
      type === 'error' &&
      responseData &&
      responseData.response &&
      responseData.response.data
    ) {
      return responseData.response.data;
    } else {
      return {
        success: false,
        message: 'Something went wrong',
      };
    }
  } catch (error) {
    return {
      success: false,
      message: 'Something went wrong',
    };
  }
};

export default axios;
